{
  "titles": {
    "appointmentDetailsHaveChanged": "예약 세부 정보가 변경되었습니다",
    "appointmentScheduled": "예약 완료",
    "appointmentConfirmed": "예약 확정",
    "appointmentRequested": "예약 요청됨",
    "missedAppointment": "예약 불이행",
    "recurringAppointmentSeriesCreated": "반복 예약 시리즈 생성됨",
    "truckArrivedAtFacility": "트럭이 시설에 도착함",
    "appointmentIsInProgressAtFacility": "시설에서 예약 진행 중",
    "appointmentRescheduled": "예약 일정 변경됨",
    "appointmentCompleted": "예약 완료됨",
    "appointmentCancelled": "예약 취소됨",
    "appointmentTagged": "예약에 태그 지정됨",
    "assetReadyForPickup": "자산 픽업 준비 완료"
  },
  "subjects": {
    "appointmentDetailsHaveChanged": "예약 세부 정보가 변경되었습니다",
    "appointmentScheduled": "{orgName} - {warehouseName} 예약 완료",
    "appointmentConfirmed": "{orgName} - {warehouseName} 예약 확정",
    "appointmentRequested": "{orgName} - {warehouseName} 예약 요청됨",
    "missedAppointment": "{orgName} - {warehouseName} 예약 불이행",
    "recurringAppointmentSeriesCreated": "반복 예약 시리즈가 생성되었습니다",
    "truckArrivedAtFacility": "트럭이 {orgName} - {warehouseName}에 도착함",
    "appointmentIsInProgressAtFacility": "{orgName} - {warehouseName}에서 예약 진행 중",
    "appointmentRescheduled": "{orgName} - {warehouseName} 예약 일정 변경됨",
    "appointmentCompleted": "{orgName} - {warehouseName} 예약 완료됨",
    "appointmentCancelled": "{orgName} - {warehouseName} 예약 취소됨",
    "appointmentTagged": "예약에 {tagName} 태그 지정됨 - {warehouseName}",
    "assetReadyForPickup": "픽업 준비 완료 - 컨테이너 {containerNumber}"
  },
  "subTitles": {
    "appointmentDetailsHaveChanged": "아래에서 위치, 날짜, 시간 및 모든 세부 정보를 확인하세요.",
    "appointmentScheduled": "아래에서 위치, 날짜, 시간 및 모든 세부 정보를 확인하세요.",
    "appointmentConfirmed": "아래에서 위치, 날짜, 시간 및 모든 세부 정보를 확인하세요.",
    "appointmentRequested": "창고의 확인을 기다려 주세요.",
    "missedAppointment": "운송사가 예약 시간에 도착하지 않았습니다.",
    "recurringAppointmentSeriesCreated": "아래에서 반복 예약의 세부 정보를 확인하세요.",
    "truckArrivedAtFacility": "아래에서 상태 및 예약 세부 정보를 확인하세요.",
    "appointmentIsInProgressAtFacility": "아래에서 상태 및 예약 세부 정보를 확인하세요.",
    "appointmentRescheduled": "아래에서 상태 및 예약 세부 정보를 확인하세요.",
    "appointmentCompleted": "아래에서 상태 및 예약 세부 정보를 확인하세요.",
    "appointmentCancelled": "모든 세부 정보와 취소 사유를 확인하세요.",
    "appointmentTagged": "아래에서 태그 이름과 정보를 확인하세요.",
    "assetReadyForPickup": "시설에 있는 자산의 픽업 준비가 완료되었습니다."
  },
  "anchorLabels": {
    "appointmentDetailsHaveChanged": "예약 보기",
    "appointmentScheduled": "예약 보기",
    "appointmentConfirmed": "예약 보기",
    "appointmentRequested": "예약 보기",
    "missedAppointment": "예약 보기",
    "recurringAppointmentSeriesCreated": "원래 예약 보기",
    "truckArrivedAtFacility": "예약 보기",
    "appointmentIsInProgressAtFacility": "예약 보기",
    "appointmentRescheduled": "예약 보기",
    "appointmentCompleted": "예약 보기",
    "appointmentCancelled": "예약 보기",
    "appointmentTagged": "예약 보기",
    "assetReadyForPickup": "예약 보기"
  },
  "descriptions": {
    "appointmentTagged": "예약 태그 설정을 사용하여 태그를 개별적으로 사용 설정하세요"
  },
  "contextLabels": {
    "assetReadyForPickup": {
      "schedulingAnchorLabel": "픽업 예약",
      "idLabel": "확인 번호",
      "ownedByLabel": "소유자:",
      "pickupScheduledForLabel": "픽업 예정 일시:",
      "noPickupScheduledLabel": "예약된 픽업 없음",
      "storeLabel": "매장",
      "openInGoogleMapsLabel": "Google 지도에서 열기",
      "appointmentDetailsLabel": "예약 세부 정보",
      "loadTypeLabel": "화물 유형",
      "warehouseInstructionsLabel": "창고 안내 사항",
      "amenitiesLabel": "이용 가능한 편의 시설",
      "ppeRequirementsLabel": "PPE 및 기타 요구 사항",
      "dockDoorLabel": "도크 도어",
      "dockInstructionsLabel": "도크 안내 사항",
      "carrierContactLabel": "운송사 담당자"
    }
  }
}
